/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2017 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/


//
// Requires
//
const Crypto = require('crypto');

//
// Sha256
//
// A class that sha256's some text
//
//
class Sha256 {

	generateIgnoreCase(someCaseInsensitiveText) {
		
		let retString;
		try {
			retString = this.generate(someCaseInsensitiveText.toLowerCase());
		}
		catch (err) {
			retString = '';
		}
		return retString;
	}
	
	//
	// Generate the unique id.
	//
	generate(someText) {
		
		let retString;
		try {
			const hash = Crypto.createHash('sha256');
			hash.update(someText);
			// return hash.digest('base64'); // This value this generates is not URL-safe
			retString = hash.digest('hex');
		}
		catch (err) {
			retString = '';
		}
		return retString;
	}
}


module.exports = Sha256;
